import { AssetLocation } from '../../models/asset-location/asset-location.model';
import { ASSET_LOCATION } from './asset-location.token';

export const provideAssets = (assetLocation: AssetLocation) => ({
    provide: ASSET_LOCATION,
    useValue: assetLocation,
});
